import { Observable } from 'rxjs';
import { $httpClient } from '@/services/httpClient';
import {
  CHANGE_PASSWORD,
  GET_CHANGES_NOTIFICATION_FLAG,
  GET_HELP_DESK_DETAILS,
  GET_ORG_NEWS,
  GET_USER_DETAILS,
  LOBBY_ACCESSIBLE,
  PERFORM_DATA_CLEANSING,
  UPDATE_USER_DETAILS,
} from '@/types/lobby.types';
import { HelpDeskDetailsModel } from '@/models/lobby/helpDeskDetails.model';
import { LoginResponse } from '@/models/response/LoginResponse';
import { LoginRequest } from '@/models/request/LoginRequest';
import { UserData } from '@/models/UserData.model';
import { BaseResponse } from '@/models/response/base/BaseResponse';

export default class LobbyService {
  private readonly baseApi: string;

  constructor() {
    this.baseApi = 'api/emp/lobby/';
  }

  public getOrgNews(): Observable<any> {
    return $httpClient.get<any>(this.baseApi + GET_ORG_NEWS);
  }

  public getHelpDeskDetails(): Observable<HelpDeskDetailsModel> {
    return $httpClient.get<any>(this.baseApi + GET_HELP_DESK_DETAILS);
  }

  public changePassword(loginRequest: LoginRequest): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>(this.baseApi + CHANGE_PASSWORD, loginRequest);
  }

  public performDataCleansing(dataCleansingRequest: UserData, token: string | null): Observable<UserData> {
    return $httpClient.post<UserData>(this.baseApi + PERFORM_DATA_CLEANSING, dataCleansingRequest,{
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  }

  public updateUserDetails(userDetailsRequest: UserData): Observable<UserData> {
    return $httpClient.post<UserData>(this.baseApi + UPDATE_USER_DETAILS, userDetailsRequest);
  }

  public getUserDetails(token: string | null): Observable<UserData> {
    return $httpClient.get<UserData>(this.baseApi + GET_USER_DETAILS, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  }

  public lobbyAccessible(): Observable<BaseResponse> {
    return $httpClient.get<BaseResponse>(this.baseApi + LOBBY_ACCESSIBLE);
  }

  public getChangesNotificationFlag(): Observable<boolean> {
    return $httpClient.get<boolean>(this.baseApi + GET_CHANGES_NOTIFICATION_FLAG);
  }
}
